/**
 * Visitor ID Management
 *
 * Generates and persists a unique visitor ID for the widget.
 * The ID is stored in localStorage and used to identify returning visitors.
 */

const STORAGE_KEY = 'longchat_visitor_id';

/**
 * Generate a UUID v4
 */
function generateUUID(): string {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
    const r = (Math.random() * 16) | 0;
    const v = c === 'x' ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
}

/**
 * Get the visitor ID from localStorage, or generate a new one
 */
export function getVisitorId(): string {
  try {
    let visitorId = localStorage.getItem(STORAGE_KEY);

    if (!visitorId) {
      visitorId = generateUUID();
      localStorage.setItem(STORAGE_KEY, visitorId);
      console.log('[LongChat] Generated new visitor ID:', visitorId);
    } else {
      console.log('[LongChat] Using existing visitor ID:', visitorId);
    }

    return visitorId;
  } catch (error) {
    // localStorage might be blocked (e.g., in incognito mode)
    console.warn('[LongChat] localStorage not available, generating temporary ID');
    return generateUUID();
  }
}

/**
 * Clear the visitor ID (for testing or logout)
 */
export function clearVisitorId(): void {
  try {
    localStorage.removeItem(STORAGE_KEY);
    console.log('[LongChat] Visitor ID cleared');
  } catch (error) {
    console.warn('[LongChat] Could not clear visitor ID');
  }
}

/**
 * Set a custom visitor ID (for authenticated users)
 */
export function setVisitorId(id: string): void {
  try {
    localStorage.setItem(STORAGE_KEY, id);
    console.log('[LongChat] Visitor ID set to:', id);
  } catch (error) {
    console.warn('[LongChat] Could not set visitor ID');
  }
}

